import React from "react";
import myStar from "../images/new/my-star.png";
import blStar from "../images/new/bl-star.png";
import lyStar from "../images/new/ly-star.png";
import blStar2 from "../images/new/bl-star2.png";
import syStar from "../images/new/sy-star.png";
import myrStar from "../images/new/myr-star.png";
import blrStar from "../images/new/blr-star.png";
import lyrStar from "../images/new/lyr-star.png";
import blrStar2 from "../images/new/blr-star2.png";
import bsStar from "../images/new/bs-star.png";
import hippiGroup from '../images/hero-hippie-group.png';
import Popup from "../components/Popup";
import { useState, useEffect, useRef } from "react";
import Rellax from "rellax";

// importing aos
import AOS from 'aos';
import 'aos/dist/aos.css';
function Home() {
  const [isOpen, setIsOpen] = useState(false);
  const togglePopup = () => {
    setIsOpen(!isOpen);
  }
  useEffect(() => {
    AOS.init();
  }, [])


  // RELLAX
  const rellaxRef = useRef();
  useEffect(() => {
    new Rellax(".animateTwo", { // <---- Via class name
      speed: 2,
      center: false,
      wrapper: '.stars',
      round: true,
      vertical: true,
      horizontal: false
    });
    new Rellax(".animateThree", { // <---- Via class name
      speed: 3,
      center: false,
      wrapper: '.stars',
      round: true,
      vertical: true,
      horizontal: false
    });
    new Rellax(".animateFour", { // <---- Via class name
      speed: 4,
      center: false,
      wrapper: '.stars',
      round: true,
      vertical: true,
      horizontal: false
    });
    new Rellax(".animateFive", { // <---- Via class name
      speed: 5,
      center: false,
      wrapper: '.stars',
      round: true,
      vertical: true,
      horizontal: false
    });
    new Rellax(".animateSix", { // <---- Via class name
      speed: 6,
      center: false,
      wrapper: '.stars',
      round: true,
      vertical: true,
      horizontal: false
    });
    new Rellax(rellaxRef.current, {
      speed: 12,
      center: false,
      wrapper: null,
      round: false,
      vertical: true,
      horizontal: false
    });
  }, []);

  return (
    <>
      <section id="home">
        <div className="sun rotate linear infinite"></div>
        <div className="header-overlay"></div>
        <div className="stars" ref={rellaxRef}>
          <div className="left">
            <img className="rellax animateTwo" speed="2" src={myStar} alt="" />
            <img className="rellax animateFour" speed="4" src={blStar} alt="" />
            <img className="rellax animateSix" speed="6" src={lyStar} alt="" />
            <img
              className="rellax animateFive"
              speed="5"
              src={blStar2}
              alt=""
            />
            <img className="rellax animateSix" speed="3" src={syStar} alt="" />
          </div>
          <div className="right">
            <img className="rellax animateTwo" speed="2" src={myrStar} alt="" />
            <img
              className="rellax animateFour"
              speed="4"
              src={blrStar}
              alt=""
            />
            <img className="rellax animateSix" speed="6" src={lyrStar} alt="" />
            <img
              className="rellax animateFive"
              speed="5"
              src={blrStar2}
              alt=""
            />
            <img
              className="rellax animateThree"
              speed="3"
              src={bsStar}
              alt=""
            />
          </div>
        </div>
        <div className="small-stars"></div>
        <div className="wrapper">
          <p className="quote">
            <span className="commas">
              Those who were seen dancing were thought to be insane by those who
              could not hear the music.
            </span>
            <br></br>
            <span className="philosopher">― Friedrich Nietzsche</span>
          </p>
          <h1 data-aos="fade-up" data-aos-delay="300">
            Welcome to the Hippieverse
          </h1>
          {/* <p data-aos="fade-up" data-aos-delay="300">
            <b>Our mission</b> is to cultivate and incentivize a space for collective wellness.
            A utopia where holders can access live coaches and specialists to
            grow the mind, body, and spirit all within a safe community.
          </p> */}

          {/* <button data-aos="fade-up" data-aos-delay="300" className="button modal-toggle" onClick={togglePopup}>
            Mint Information
          </button> */}
        </div>
        <div className="hippie-group w-screen absolute bottom-0">
          <img src={hippiGroup} alt="" />
        </div>
      </section>

      {isOpen && (
        <Popup
          handleClose={togglePopup}
          popupClass={isOpen ? "modal openWithTrans" : "modal"}
          animationClass={
            isOpen
              ? "modal-wrapper modal-transition"
              : "modal-wrapper modal-no-transition"
          }
        />
      )}
    </>
  );
}

export default Home;
